module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.woff?4e3cd9a3cdc712497317f0c8742bbf2d";